import { createTabPageDescriptor } from "@/lib/tabs/pageDescriptorUtils";

export const USER_TAB_PAGES = {
  DashboardPage: createTabPageDescriptor(
    "DashboardPage",
    () => import("@/components/pages/user/DashboardPage"),
  ),
  UsersPage: createTabPageDescriptor(
    "UsersPage",
    () => import("@/components/pages/user/UsersPage/UsersPage"),
  ),
  ExternalInvitesPage: createTabPageDescriptor(
    "ExternalInvitesPage",
    () => import("@/components/pages/user/UsersPage/ExternalInvitesPage"),
  ),
  UserPage: createTabPageDescriptor(
    "UserPage",
    () => import("@/components/pages/user/UsersPage/UserPage/UserPage"),
  ),
  CompanyPage: createTabPageDescriptor(
    "CompanyPage",
    () => import("@/components/pages/user/CompanyPage/CompanyPage"),
  ),
  OrganizationsPage: createTabPageDescriptor(
    "OrganizationsPage",
    () => import("@/components/pages/user/OrganizationsPage/OrganizationsPage"),
  ),
  LogsPage: createTabPageDescriptor(
    "LogsPage",
    () => import("@/components/pages/user/LogsPage/LogsPage"),
  ),
  MarketplacePage: createTabPageDescriptor(
    "MarketplacePage",
    () => import("@/components/pages/user/Marketplace/MarketplacePage"),
  ),
  NewsPage: createTabPageDescriptor(
    "NewsPage",
    () => import("@/components/pages/user/News/NewsPage"),
  ),
  ServicePage: createTabPageDescriptor(
    "ServicePage",
    () => import("@/components/pages/user/Marketplace/ServicePage"),
  ),
  PartnerPage: createTabPageDescriptor(
    "PartnerPage",
    () => import("@/components/pages/user/Marketplace/PartnerPage"),
  ),
  AmainvoicePage: createTabPageDescriptor(
    "AmainvoicePage",
    () => import("@/components/pages/user/Tools/Amainvoice"),
  ),
  BillbeePage: createTabPageDescriptor(
    "BillbeePage",
    () => import("@/components/pages/user/Tools/Billbee"),
  ),
  ReplycoPage: createTabPageDescriptor(
    "ReplycoPage",
    () => import("@/components/pages/user/Tools/Replyco"),
  ),
  VentoryOnePage: createTabPageDescriptor(
    "VentoryOnePage",
    () => import("@/components/pages/user/Tools/VentoryOne"),
  ),
};
